<div class="alphabetical-keyboard">
    <!-- Toggle Uppercase/Lowercase -->
    <!--    <div class="keyboard-row toggle-row">-->
    <!--        <button-->
    <!--            mat-raised-button-->
    <!--            color="accent"-->
    <!--            class="toggle-case"-->
    <!--            (click)="toggleCase()"-->
    <!--        >-->
    <!--            {{ isUppercase ? '⇧ SHIFT (Uppercase)' : '⇧ SHIFT (Lowercase)' }}-->
    <!--        </button>-->
    <!--    </div>-->

    <!-- Row 1 -->
    <div class="keyboard-row">
        <button
            mat-raised-button
            color="primary"
            *ngFor="let key of row1"
            (click)="onKeyPress(key)"
        >
            {{ key }}
        </button>
    </div>

    <!-- Row 2 -->
    <div class="keyboard-row">
        <button
            mat-raised-button
            color="primary"
            *ngFor="let key of row2"
            (click)="onKeyPress(key)"
        >
            {{ key }}
        </button>
    </div>

    <!-- Row 3 -->
    <div class="keyboard-row">
        <button
            mat-raised-button
            color="primary"
            *ngFor="let key of row3"
            (click)="onKeyPress(key)"
        >
            {{ key }}
        </button>
    </div>

    <!-- Row 4: Space and Enter -->
    <div class="keyboard-row">
        <button
            mat-raised-button
            color="accent"
            class="key special-key"
            (click)="onKeyPress(' ')"
        >
            SPACE
        </button>
        <button
            mat-raised-button
            color="warn"
            class="key special-key"
            (click)="onKeyPress('ENTER')"
        >
            ENTER
        </button>
    </div>
</div>
